export const formatAmountToPriceDispplay = (amount: number) => {
	return (amount / 100).toLocaleString('en-IN', {
		style: 'currency',
		currency: 'INR',
		maximumFractionDigits: 0,
	});
};

export const formatTimeInHMS = (seconds: number) => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	const formattedTime = [];

	if (hours > 0) {
		formattedTime.push(`${hours}h`);
	}

	if (minutes > 0) {
		formattedTime.push(`${minutes}m`);
	}

	if (remainingSeconds > 0 || formattedTime.length === 0) {
		formattedTime.push(`${remainingSeconds}s`);
	}

	return formattedTime.join(' ');
};

export const generateValidity = (duration: any, validityType: string) => {
	let timeAgo;
	if (duration.asYears() >= 1) {
		const yearsAgo = Math.floor(duration.asYears());
		timeAgo = `${yearsAgo} ${yearsAgo > 1 ? 'years' : 'year'} ${validityType === 'validFor' ? '' : 'ago'}`;
	} else if (duration.asMonths() >= 1) {
		const monthsAgo = Math.floor(duration.asMonths());
		timeAgo = `${monthsAgo} ${monthsAgo > 1 ? 'months' : 'month'} ${validityType === 'validFor' ? '' : 'ago'}`;
	} else if (duration.asWeeks() >= 1) {
		const weeksAgo = Math.floor(duration.asWeeks());
		timeAgo = `${weeksAgo} ${weeksAgo > 1 ? 'weeks' : 'week'} ${validityType === 'validFor' ? '' : 'ago'}`;
	} else if (duration.asDays() >= 1) {
		const daysAgo = Math.floor(duration.asDays());
		timeAgo = `${daysAgo} ${daysAgo > 1 ? 'days' : 'day'} ${validityType === 'validFor' ? '' : 'ago'}`;
	} else if (duration.asHours() >= 1) {
		const hoursAgo = Math.floor(duration.asHours());
		timeAgo = `${hoursAgo} ${hoursAgo > 1 ? 'hours' : 'hour'} ${validityType === 'validFor' ? '' : 'ago'}`;
	} else {
		timeAgo = validityType === 'validFor' ? 'few minutes ' : 'just now';
	}

	return timeAgo;
};

export function isValidObjectId(id: string): boolean {
	// Check if the id is a 24-character hexadecimal string
	const objectIdPattern = /^[a-f\d]{24}$/i;
	return objectIdPattern.test(id);
}
